<div class="right-side p-5">
  <h2>Buyer Requirement Form</h2>
  <div class="section">
    <div class="bkgimage">
      <form [formGroup]="BuyerForm">
        <!-- Buyer Requirement Form -->
        <div class="xyz">

          <div class="row mt-4">
            <!-- Left Column -->
            <div class="col-md-6">
              <!-- Buyer Requirement Name -->
              <div class="mb-3">
                <label for="buyerRequirementName">Buyer Requirement Name: <span class="text-danger">*</span></label>
                <input class="form-control"
                       type="text"
                       id="buyerrequirementname"
                       formControlName="buyerRequirementName"
                       placeholder="Enter Buyer Requirement Name"
                       maxlength="200"
                       (blur)="removeExtraSpaces('buyerRequirementName')"
                       required>
                <div *ngIf="BuyerForm.controls['buyerRequirementName'].invalid && (BuyerForm.controls['buyerRequirementName'].dirty || BuyerForm.controls['buyerRequirementName'].touched)">
                  <small class="text-danger" *ngIf="BuyerForm.controls['buyerRequirementName'].errors?.['required']">
                    Buyer Requirement Name is required.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['buyerRequirementName'].errors?.['minlength']">
                    Must be at least 2 characters long.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['buyerRequirementName'].errors?.['maxlength']">
                    Cannot exceed 200 characters.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['buyerRequirementName'].errors?.['pattern']">
                    Must contain only letters.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['buyerRequirementName'].errors?.['pattern']">Buyer Requirement Name must only contain letters.</small>
                </div>
              </div>

              <div class="mb-3">
                <label for="budget">Budget: <span class="text-danger">*</span></label>
                <input class="form-control"
                       type="number"
                       id="budget"
                       formControlName="budget"
                       placeholder="Enter Budget"
                       (blur)="removeExtraSpaces('budget')"
                       required>
                <div *ngIf="BuyerForm.controls['budget'].invalid && (BuyerForm.controls['budget'].dirty || BuyerForm.controls['budget'].touched)">
                  <small class="text-danger" *ngIf="BuyerForm.controls['budget'].errors?.['required']">
                    Budget is required.
                  </small>
                </div>
              </div>

              <!-- Category -->
              <div class="mb-3">
                <label for="category">Category: <span class="text-danger">*</span></label>
                <select class="form-control"
                        id="category"
                        maxlength="200"
                        formControlName="category"
                        required>
                  <option value="" disabled selected>-Select Type-</option>
                  <option value="Category1">Category1</option>
                  <option value="Category2">Category2</option>
                </select>
                <div *ngIf="BuyerForm.controls['category'].invalid && (BuyerForm.controls['category'].dirty || BuyerForm.controls['category'].touched)">
                  <small class="text-danger" *ngIf="BuyerForm.controls['category'].errors?.['required']">
                    Category is required.
                  </small>
                </div>
              </div>

              <!-- HSN Code -->
              <div class="mb-3">
                <label for="hsn-code">HSN Code: <span class="text-danger">*</span></label>
                <input class="form-control"
                       type="text"
                       id="hsncode"
                       maxlength="8"
                       formControlName="hsnCode"
                       placeholder="Enter HSN Code"
                       (blur)="removeExtraSpaces('hsnCode')"
                       required>
                <div *ngIf="BuyerForm.controls['hsnCode'].invalid && (BuyerForm.controls['hsnCode'].dirty || BuyerForm.controls['hsnCode'].touched)">
                  <small class="text-danger" *ngIf="BuyerForm.controls['hsnCode'].errors?.['required']">
                    HSN Code is required.
                  </small>
                </div>
              </div>

              <!-- Product -->
              <div class="mb-3">
                <label for="product">Product: <span class="text-danger">*</span></label>
                <input class="form-control"
                       type="text"
                       id="product"
                       formControlName="product"
                       placeholder="Enter Product"
                       maxlength="200"
                       (blur)="removeExtraSpaces('product')"
                       required>
                <div *ngIf="BuyerForm.controls['product'].invalid && (BuyerForm.controls['product'].dirty || BuyerForm.controls['product'].touched)">
                  <small class="text-danger" *ngIf="BuyerForm.controls['product'].errors?.['required']">
                    Product is required.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['product'].errors?.['minlength']">
                    Must be at least 2 characters long.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['product'].errors?.['maxlength']">
                    Cannot exceed 200 characters.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['product'].errors?.['pattern']">product  must only contain letters.</small>
                </div>
              </div>
            </div>

            <!-- Right Column -->
            <div class="col-md-6">
              <!-- Location -->
              <div class="mb-3">
                <label for="location">Location: <span class="text-danger">*</span></label>
                <input class="form-control"
                       type="text"
                       id="location"
                       formControlName="location"
                       placeholder="Enter Location"
                       maxlength="200"
                       (blur)="removeExtraSpaces('location')"
                       required>
                <div *ngIf="BuyerForm.controls['location'].invalid && (BuyerForm.controls['location'].dirty || BuyerForm.controls['location'].touched)">
                  <small class="text-danger" *ngIf="BuyerForm.controls['location'].errors?.['required']">
                    Location is required.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['location'].errors?.['minlength']">
                    Must be at least 2 characters long.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['location'].errors?.['maxlength']">
                    Cannot exceed 200 characters.
                  </small>
                  <small class="text-danger" *ngIf="BuyerForm.controls['location'].errors?.['pattern']">location  must only contain letters.</small>
                </div>
              </div>

              <mat-form-field appearance="outline">
    <mat-label>From Date</mat-label>
    <input matInput [matDatepicker]="picker1" formControlName="timelineFromDate">
    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>To Date</mat-label>
    <input matInput [matDatepicker]="picker2" formControlName="timelineToDate">
    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
  </mat-form-field>
              

              <!-- Terms & Conditions -->
              <div class="mb-3">
                <label for="terms">Terms & Conditions: <span class="text-danger">*</span></label>
                <textarea class="form-control"
                          id="terms"
                          formControlName="termAndConditions"
                          rows="3"
                          placeholder="Enter Terms & Conditions"
                          required>
                </textarea>
              </div>
            </div>
          </div>

          <!-- Submit Buttons -->
          <div class="text-center mt-3">
            <button class="btn btn-success me-2" id="btnSave" type="submit" (click)="onSubmit()">{{buttonText}}</button>
            <button class="btn btn-danger" id="btncancel" type="reset" (click)="onCancel()">Cancel</button>
          </div>

          <!-- View Buyer Requirement Details -->
          <div class="mt-4">
            <h2>Buyer Requirement Details</h2>
            <div class="row">
              <div class="text-end">
                <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
              </div>
            <div class="col-lg-7 col-sm-12">
              <div class="search-container">
                <mat-form-field class="search-input w-75" appearance="outline">
                  <mat-label>Search</mat-label>
                  <input matInput formControlName="searchControl" />
                </mat-form-field>
                <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(BuyerForm.get('searchControl')?.value ?? '')" id="btnSearch">
                  <i class="bi bi-search fs-4"></i>
                </button>
                <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                  <i class="bi bi-arrow-clockwise fs-4"></i>
                </button>
              </div>
              <div *ngIf="BuyerForm.get('searchControl')?.invalid && (BuyerForm.get('searchControl')?.touched || BuyerForm.get('searchControl')?.dirty)">
                <small *ngIf="BuyerForm.get('searchControl')?.errors?.['pattern']" class="text-danger">
                  Invalid search term.
                </small>
              </div>

            </div>
            </div>

          <!--<div class="table-responsive">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th hidden>Reverse Buyer Requirement ID</th>
          <th>Buyer Requirement Name</th>
          <th>Budget</th>
          <th>Category</th>
          <th>Hsn Code</th>
          <th>Product</th>
          <th>Location</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let x of buyerrequirementdetails; let i = index">
          <td>{{ i + 1 }}</td>
          <td hidden>{{ x.reverseBuyerRequirementID }}</td>
          <td>{{ x.buyerRequirementName }}</td>
          <td>{{ x.budget }}</td>
          <td>{{ x.category }}</td>
          <td>{{ x.hsnCode }}</td>
          <td>{{ x.product }}</td>
          <td>{{ x.location }}</td>
          <td>
            <button (click)="onEdit(x.reverseBuyerRequirementID)" class="btn btn-primary btn-sm me-2">
              <i class="bi bi-pencil"></i> Edit
            </button>
            <button (click)="onDelete(x.reverseBuyerRequirementID)" class="btn btn-danger btn-sm">
              <i class="bi bi-trash"></i> Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <mat-paginator class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [disabled]="disabled"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex">
    </mat-paginator>
  </div>-->

          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="buyerRequirementName" matSort matSortDirection="desc" matSortDisableClear>
              <ng-container matColumnDef="Sr.No">
                <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
              </ng-container>
              <ng-container matColumnDef="reverseBuyerRequirementID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header hidden="hidden">reverseBuyerRequirementID</th>
                <td mat-cell *matCellDef="let el" hidden="hidden"> {{el.reverseBuyerRequirementID}} </td>
              </ng-container>
              <ng-container matColumnDef="buyerRequirementName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Buyer Requirement Name</th>
                <td mat-cell *matCellDef="let el"> {{el.buyerRequirementName}} </td>
              </ng-container>
              <ng-container matColumnDef="budget">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Budget</th>
                <td mat-cell *matCellDef="let el"> {{el.budget}} </td>
              </ng-container>
              <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
                <td mat-cell *matCellDef="let el"> {{el.category}} </td>
              </ng-container>
              <ng-container matColumnDef="hsnCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>HSNCode</th>
                <td mat-cell *matCellDef="let el"> {{el.hsnCode}} </td>
              </ng-container>
              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
                <td mat-cell *matCellDef="let el"> {{el.product}} </td>
              </ng-container>
              <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
                <td mat-cell *matCellDef="let el"> {{el.location}} </td>
              </ng-container>
              <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                <td mat-cell *matCellDef="let el">
                  <span (click)="onEdit(el.reverseBuyerRequirementID)" class="btn btn-primary btn-sm mt-1">
                    <i class="bi bi-pencil"></i> Edit
                  </span>
                  &nbsp;&nbsp;
                  <span (click)="onDelete(el.reverseBuyerRequirementID)" class="btn btn-danger btn-sm mt-1">
                    <i class="bi bi-trash"></i> Delete
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              Row shown when there is no matching data.
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>

              </tr>
            </table>

          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>

        </div>
          </div>
      </form>
    </div>
  </div>
</div>





